import { render, staticRenderFns } from "./RegisterUpload.vue?vue&type=template&id=2afd85f0"
import script from "./RegisterUpload.vue?vue&type=script&lang=js"
export * from "./RegisterUpload.vue?vue&type=script&lang=js"
import style0 from "./RegisterUpload.vue?vue&type=style&index=0&id=2afd85f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports